const WarningIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M22.6875 15.4875L14.6625 2.57501C14.025 1.71251 13.05 1.22501 12 1.22501C10.9125 1.22501 9.93753 1.71251 9.33753 2.57501L1.31253 15.4875C0.562527 16.5 0.450027 17.8125 1.01253 18.9375C1.57503 20.0625 2.70003 20.775 3.97503 20.775H20.025C21.3 20.775 22.425 20.0625 22.9875 18.9375C23.55 17.85 23.4375 16.5 22.6875 15.4875ZM21.4875 18.1875C21.1875 18.75 20.6625 19.0875 20.025 19.0875H3.97503C3.33753 19.0875 2.81253 18.75 2.51253 18.1875C2.25003 17.625 2.28753 16.9875 2.66253 16.5L10.6875 3.58751C10.9875 3.17501 11.475 2.91251 12 2.91251C12.525 2.91251 13.0125 3.13751 13.3125 3.58751L21.3375 16.5C21.7125 16.9875 21.75 17.625 21.4875 18.1875Z"
        fill="currentColor"
      />
      <path
        d="M12.0002 8.20003C11.5502 8.20003 11.1377 8.57503 11.1377 9.06253V13.15C11.1377 13.6 11.5127 14.0125 12.0002 14.0125C12.4877 14.0125 12.8627 13.6375 12.8627 13.15V9.02503C12.8627 8.57503 12.4502 8.20003 12.0002 8.20003Z"
        fill="currentColor"
      />
      <path
        d="M12.0002 15C11.5502 15 11.1377 15.375 11.1377 15.8625V16.05C11.1377 16.5 11.5127 16.9125 12.0002 16.9125C12.4877 16.9125 12.8627 16.5375 12.8627 16.05V15.825C12.8627 15.375 12.4502 15 12.0002 15Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default WarningIcon;

export const WarningSmallIcon = () => {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17.0152 11.6158L10.9964 1.93145C10.5183 1.28457 9.78703 0.918945 8.99953 0.918945C8.18391 0.918945 7.45266 1.28457 7.00266 1.93145L0.983907 11.6158C0.421407 12.3752 0.337032 13.3596 0.758907 14.2033C1.18078 15.0471 2.02453 15.5814 2.98078 15.5814H15.0183C15.9745 15.5814 16.8183 15.0471 17.2402 14.2033C17.662 13.3877 17.5777 12.3752 17.0152 11.6158ZM16.1152 13.6408C15.8902 14.0627 15.4964 14.3158 15.0183 14.3158H2.98078C2.50266 14.3158 2.10891 14.0627 1.88391 13.6408C1.68703 13.2189 1.71516 12.7408 1.99641 12.3752L8.01516 2.69082C8.24016 2.38145 8.60578 2.18457 8.99953 2.18457C9.39328 2.18457 9.75891 2.35332 9.98391 2.69082L16.0027 12.3752C16.2839 12.7408 16.312 13.2189 16.1152 13.6408Z"
        fill="currentColor"
      />
      <path
        d="M8.99941 6.15039C8.66191 6.15039 8.35254 6.43164 8.35254 6.79727V9.86289C8.35254 10.2004 8.63379 10.5098 8.99941 10.5098C9.36504 10.5098 9.64629 10.2285 9.64629 9.86289V6.76914C9.64629 6.43164 9.33691 6.15039 8.99941 6.15039Z"
        fill="currentColor"
      />
      <path
        d="M8.99941 11.25C8.66191 11.25 8.35254 11.5312 8.35254 11.8969V12.0375C8.35254 12.375 8.63379 12.6844 8.99941 12.6844C9.36504 12.6844 9.64629 12.4031 9.64629 12.0375V11.8688C9.64629 11.5313 9.33691 11.25 8.99941 11.25Z"
        fill="currentColor"
      />
    </svg>
  );
};
